export const isValueValid = (error, value) => {
  return !error && (value ?? '').toString().trimStart() !== '';
};